module.exports = __webpack_public_path__ + "static/media/cliente.2ca3bc2e.svg";